
import React, { useState } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { useDispatch} from "react-redux";
import  SelectedSessionAudit from "./SelectedSessionAudit";
import { clearOptixData } from "../../store/comprehensiveImageViewer/imageViewerSlice";

const MobileViewContent = ({data}) => {
    const [selectedSessionAudit, setSelectedSessionAudit] = useState(null);
    const [time,setTime]=useState(null);
    const [clicked,setClicked]=useState(false);
    const [noOfOriginalImg,setNoOfOriginalImg]=useState(null);
    const formattedDate = new Date(data.auditStartTime);

    // Get the time components (hours, minutes, and seconds)
    const hours = formattedDate.getUTCHours();
    const minutes = formattedDate.getUTCMinutes();
    const seconds = formattedDate.getUTCSeconds();

    // Format the time as HH:MM:SS
    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    const dispatch=useDispatch();

    const handleCardClick = (sessionAudit,time,count) => {
      setSelectedSessionAudit(sessionAudit);
      setTime(time);
      setNoOfOriginalImg(count);
      setClicked(!clicked);
      dispatch(clearOptixData());

    };
    // console.log(selectedSessionAudit);
  return (
    <>
            <Card style={{ width:"21vw", padding:"0px",cursor:"pointer" }}  onClick={() => handleCardClick(data.audit_ids, data.auditStartTime, data.original_image_count)}>
              <CardContent style={{padding:"5px"}}>
                <Typography
                  variant="subtitle2"
                  color="text.primary"
                  sx={{ fontSize: "11px", wordBreak: "break-all" ,color:"grey"}}
                >
                  {data.address}
                </Typography>
                <Typography
                  variant="subtitle1"
                  component="div"
                  sx={{ fontSize: "11px", wordBreak: "break-all",color:"grey" }}
                >
                  {data.session_audit}
                </Typography>
                <Typography variant="subtitle2" color="text.secondary" sx={{ fontSize: "11px",fontWeight:"550"}}>
                  {data.date} {formattedTime}
                </Typography>
                
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: "5px",
                    marginBottom: "2px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <CheckCircleIcon color="success" style={{fontSize:"14px"}}/>
                    <Typography variant="caption"> Clicked</Typography>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    {data.completed ? (
                      <CheckCircleIcon color="success" style={{fontSize:"14px"}} />
                    ) : (
                      <CancelIcon color="error" style={{fontSize:"14px"}} />
                    )}

                    <Typography variant="caption" > Uploaded</Typography>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    {data.completed && data.processed_image ? (
                      <CheckCircleIcon color="success" style={{fontSize:"14px"}} />
                    ) : (
                      <CancelIcon color="error" style={{fontSize:"14px"}}/>
                    )}
                    <Typography variant="caption"> Processed</Typography>
                  </div>
                </div>
                <Typography variant="caption" color="body1" style={{fontSize:"11px",color:"grey"}} >
                  {data.completed && data.processed_image
                    ? "Done, Acknowledgement Sent"
                    : data.completed !== 1
                    ? "Audit Not Uploaded"
                    : data.processed_image !== 1
                    ? "Audit Uploaded, In Processing"
                    : ""}
                </Typography>
                {/* <Button onClick={() => handleCardClick(d.session_audit)}>click</Button> */}
              </CardContent>
            </Card>
            {clicked && <SelectedSessionAudit auditIDs={selectedSessionAudit} time={time} count={noOfOriginalImg}/>}
            </>
  )
}

export default MobileViewContent;